import React from 'react';
import { Link } from '@inertiajs/react';
import { TOPICS, topicPath } from './topics';

const PrevNext: React.FC<{ current: string }> = ({ current }) => {
  const i = TOPICS.findIndex((t) => t.id === current);
  const prev = i > 0 ? TOPICS[i - 1] : undefined;
  const next = i >= 0 ? TOPICS[i + 1] : undefined;

  return (
    <div className="mt-11 flex justify-between gap-3 border-t border-gray-200 pt-4 text-sm">
      {prev ? (
        <Link href={topicPath(prev.id)} className="text-blue-600">
          <small className="block text-xs text-gray-400">上一节</small>← {prev.label}
        </Link>
      ) : (
        <span />
      )}
      {next && (
        <Link href={topicPath(next.id)} className="ml-auto text-right text-blue-600">
          <small className="block text-xs text-gray-400">下一节</small>
          {next.label} →
        </Link>
      )}
    </div>
  );
};

export default PrevNext;
